import { render, staticRenderFns } from "./ComprareporteDetail.vue?vue&type=template&id=f0f2a78c&"
import script from "./ComprareporteDetail.vue?vue&type=script&lang=js&"
export * from "./ComprareporteDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports